export const shipiumResources = {
  'shipium_terms.administrator.description': 'User with permission to perform all actions within the Shipium console',
  'shipium_terms.administrator.term': 'Administrator',
  'shipium_terms.editor.description': 'Users with permissions to create labels within the Shipium console',
  'shipium_terms.editor.term': 'Editor',
  'shipium_terms.viewer.description': 'User with permission to view information within the Shipium console',
  'shipium_terms.viewer.term': 'Viewer',
  'shipium_terms.site_manager.description': 'Pack App User with full permissions to manage multiple sites (Origins)',
  'shipium_terms.site_manager.term': 'Site Manager',
  'shipium_terms.site_associate.description': 'Pack App User with limited permissions at a single site (Origin)',
  'shipium_terms.site_associate.term': 'Site Associate',
};

export type ShipiumResourceKey =
  | 'shipium_terms.administrator.description'
  | 'shipium_terms.administrator.term'
  | 'shipium_terms.editor.description'
  | 'shipium_terms.editor.term'
  | 'shipium_terms.viewer.description'
  | 'shipium_terms.viewer.term'
  | 'shipium_terms.site_manager.description'
  | 'shipium_terms.site_manager.term'
  | 'shipium_terms.site_associate.description'
  | 'shipium_terms.site_associate.term';
